import classNames from "classnames";
import { EmblaIcons, EmblaIconsType } from "core/emblaIcons";
import { EmblaIcon } from "../emblaIcon/emblaIcon";
import { useCallback, useState } from "react";

type AriaSettings = {
    standardText: string;
    confirmText?: string;
    negateText?: string;
}

type IconProps = {
    onClick: () => void;
    iconName: EmblaIconsType;
    className?: string;
    needConfirmation?: boolean;
    aria?: AriaSettings;
}

const ClickableIcon = ({onClick, iconName, className, aria, needConfirmation=false}: IconProps) => {

    const [confirmationActive, setConfirmationActive] = useState(false);

    const handleOnClick = useCallback(() => {
        needConfirmation
            ? setConfirmationActive(true)
            : onClick()
    }, [needConfirmation, onClick]);

    const confirm = async (confirmed: boolean) => {
        if (confirmed)
            onClick();

        setConfirmationActive(false);
    }

    const confirmBtnClasses = "btn btn-icon btn-outline";

    return (
        <>
            {!confirmationActive &&
                <div className={classNames(className)} role='button' onClick={(e) => handleOnClick()} aria-label={aria?.standardText}>
                    <EmblaIcon iconName={iconName} />
                </div>
            }

            {confirmationActive &&
                <div className="btn-group confirm" role="group">
                    <button className={classNames(confirmBtnClasses, "btn-danger")} onClick={() => confirm(false)} aria-label={aria?.negateText ?? aria?.standardText}>
                        <EmblaIcon iconName={EmblaIcons.Danger} />
                    </button>

                    <button className={classNames(confirmBtnClasses, "btn-success")} onClick={() => confirm(true)} aria-label={aria?.confirmText ?? aria?.standardText}>
                        <EmblaIcon iconName={EmblaIcons.Success} />
                    </button>
                </div>
            }
        </>
    );
};

export default ClickableIcon;
